module.exports = __webpack_public_path__ + "591c072a240d128c40408cb754aeb472.fbx";